import { render, staticRenderFns } from "./InstitutionAndDepartment.vue?vue&type=template&id=7a4e4c37&"
import script from "./InstitutionAndDepartment.vue?vue&type=script&lang=js&"
export * from "./InstitutionAndDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports